export const PRIMARY_BUTTON_CLR = "#003366";
export const PRIMARY_APP_CLR = "#399ddb";
export const SECONDARY_APP_CLR = "#003366";
export const TERTIARY_APP_CLR = "#FF0000";
export const TABLE_BORDER_APP_CLR = "#0b02ba";
export const WEB_APP_FONT_CLR = "#0b042e";